import { ReactElement } from 'react'
import { Observable } from 'rxjs'

export type TourEntry = {
    skipToNext?: Observable<Voidable<boolean>>
    skipNext?: Observable<boolean>
    elements: () => Observable<HTMLElement[]>[]
    elementLookup?: (element: HTMLElement) => Nullable<HTMLElement>
    content: string | ReactElement
    disableGutter?: boolean
    preferredPosition?: TourOverlayPosition
    disableNext?: boolean
    interceptClick?: boolean
    watchAttributeChanges?: boolean
    potentialTransitionLag?: number
    containingScrollableAreaSelector?: string
    minContentSize?: {
        width: number
        height: number
    }
    disablePopoverViewable?: boolean
    onNext?: () => void
}

export type WindowSizing = {
    windowWidth: number
    windowHeight: number
    bodyWidth: number
    bodyHeight: number
}

export type IsolatorLocations = {
    left: DOMRect
    top: DOMRect
    right: DOMRect
    bottom: DOMRect
}

export enum TourOverlayPosition {
    TOP = 'top',
    BOTTOM = 'bottom',
    LEFT = 'left',
    RIGHT = 'right'
}
